import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { routeFrontOfficeSchoolRankingCommonUser } from '@/lib/routes/front/common/routeFrontOfficeSchoolRankingCommonUser'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeSchoolUserTeam = [
  ...routeFrontOfficeSchoolRankingCommonUser,
  ...routeFrontOfficeCommonUser,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISCHOOL],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_USER_TEAM],
}))
